/**
 * SubscriptionUserService
 * Service for SubscriptionUser entity operations
 * Route: api/subscriptionusers
 * Controller: SubscriptionUsersController.cs
 */
import { CrudService } from '../base/CrudService';
export class SubscriptionUserService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SubscriptionUserService.DEFAULT_SERVICE_PATH,
            basePath: SubscriptionUserService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all users for a specific subscription
     */
    async getBySubscription(subscriptionId) {
        const response = await this.http.get(this.buildUrl(`by-subscription/${subscriptionId}`));
        return response.data ?? [];
    }
}
SubscriptionUserService.DEFAULT_SERVICE_PATH = 'suppliers';
SubscriptionUserService.BASE_PATH = 'api/subscriptionusers';
//# sourceMappingURL=SubscriptionUserService.js.map